// lockScreenReducer/lockScreenActions action types.
export const SET_TRANSITION_LOCK_SCREEN = 'SET_TRANSITION_LOCK_SCREEN';

// transitionReducer/transitionActions action types.
export const SET_TRANSITION = 'SET_TRANSITION';

export const SET_CONTEXT = 'SET_CONTEXT';

export const SET_SETTINGS = 'SET_SETTINGS';

export const SET_SELECTED_DATE = 'SET_SELECTED_DATE';
export const DECREMENT_SEVEN_DAYS = 'DECREMENT_SEVEN_DAYS';
export const INCREMENT_SEVEN_DEYS = 'INCREMENT_SEVEN_DEYS';
export const INCREMENT_MONTH = 'INCREMENT_MONTH';
export const DECREMENT_MONTH = 'DECREMENT_MONTH';
export const SET_DRAWER = 'SET_DRAWER';

export const SET_WIDGET_FILTES = 'SET_WIDGET_FILTES';
export const SELECT_WIDGET_FILTES = 'SELECT_WIDGET_FILTES';

export const SET_MEASURES = 'SET_MEASURES';
export const SET_UNITS = 'SET_UNITS';

export const SET_SELECTED_SEVEN_DAYS = 'SET_SELECTED_SEVEN_DAYS';
export const SET_WIDGET_FILTES_SELECTED_DATE = 'SET_WIDGET_FILTES_SELECTED_DATE';

export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_LOADING = 'SET_LOADING';